import * as i0 from "@angular/core";
export class LsHelperService {
    constructor() { }
    set(key, value) {
        window.localStorage.setItem(key, JSON.stringify(value));
    }
    get(key) {
        var data = window.localStorage.getItem(key);
        return JSON.parse(data);
    }
}
LsHelperService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LsHelperService_Factory() { return new LsHelperService(); }, token: LsHelperService, providedIn: "root" });
